/*eslint-disable no-undef*/
/* eslint no-underscore-dangle: 0 */

__webpack_public_path__ = window.remoteUrl;
import LazyLoad from '@grpn/gig-components/lib/LazyLoad';
import createStore from 'app/desktop/store';
import renderComponent from 'app/common/helpers/renderComponent';
import InAppMessagesRoot from 'app/desktop/components/inAppMessages/inAppMessages';
import BottomCookieBannerRoot from 'app/desktop/components/cookieBanner/BottomCookieBanner';
import MyStuffLayoutRoot from 'app/desktop/components/userNav/MyStuffLayout';
import subscribers from 'app/common/subscribers';
import DesktopApi from 'app/api/desktop';
import checkInitialExp from 'app/desktop/helpers/experiments';
import { dispatchEvent } from 'src/frontend/helper/event';
import { initHistoryStates } from 'app/common/helpers/history_events';

import { init, fetchData, fetchIamData } from 'app/desktop/actions/app';

import { windowLoaded } from '@grpn/document-states';

const store = createStore();

const DoNotSell = LazyLoad({
  loader: () =>
    import(/* webpackChunkName: "DoNotSell" */ 'app/common/components/donotsell/DoNotSell'),
  renderPlaceholder: () => null,
});
DoNotSell.preload();

export default () => {
  // add `process.env.NODE_ENV !== 'production' ||` back after preact is ready!
  if (Cookie.get('lsdev')) {
    require('preact/devtools');
  }
  // subscribe state change
  subscribers(store);
  // create window.LSApp API
  DesktopApi.init(store);

  const initState = window.__LS_INITIAL_STATE__;

  const isSearchHeader = document.head.dataset.header === 'default';
  const isLiteHeader = document.head.dataset.header === 'lite';

  checkInitialExp({ isLiteHeader });

  // // init app data
  store.dispatch(init(initState));

  store.dispatch(fetchIamData());

  windowLoaded.then(() => {
    // // lazy load data from storage
    store.dispatch(fetchData());
  });

  initHistoryStates(window.history);

  // render root components

  renderComponent(store, InAppMessagesRoot, 'ls-in-app-messages');
  renderComponent(store, BottomCookieBannerRoot, 'gdpr-bottom-banner');
  renderComponent(store, MyStuffLayoutRoot, 'ls-my-stuff-wrapper');
  renderComponent(store, DoNotSell, 'ls-do-not-sell');

  if (document.body.classList.contains('ls-resp')) {
    import(/* webpackChunkName: "responsive" */ 'app/desktop/responsive').then(
      ({ default: Responsive }) => {
        new Responsive(store.dispatch);
      }
    );
  }

  function renderHeader(headerComponent) {
    renderComponent(store, headerComponent, 'ls-header', 'ls-header-wrapper');
    dispatchEvent('loaded-preact-search');
  }

  if (isSearchHeader) {
    if (!initState.flags.desktopHeader2019) {
      import(/* webpackChunkName: "desktop-preact-header" */ 'app/desktop/components/ssr/LegacyHeader').then(
        ({ default: LegacyHeader }) => renderHeader(LegacyHeader)
      );
    } else {
      import(/* webpackChunkName: "desktop-preact-redesign-header" */ 'app/desktop/components/header/Header').then(
        ({ default: Header }) => renderHeader(Header)
      );
    }
  }

  if (isLiteHeader) {
    import(/*webpackChunkName: "desktop-preact-lite-header" */ 'app/desktop/components/header/LiteHeader').then(
      ({ default: LiteHeader }) => {
        renderComponent(
          store,
          LiteHeader,
          'ls-lite-header',
          'ls-lite-header-wrapper'
        );
        dispatchEvent('loaded-preact-search');
      }
    );
  }
};
